import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

/* Components */
import ConversionFlowForm from './ConversionFlowForm';
import ConversionFlowOverlay from "./ConversionFlowOverlay";
import ConversionFlowDatalayer from "./ConversionFlowDatalayer";

export default function ConversionFlow({ flowUrl, triggerSelector, triggerEvent = 'click', datalayerData, webspace, locale }) {
    const { ...form } = useForm({ shouldUnregister: true, mode: 'onTouched' });
    const [open, setOpen] = useState(false);

    const handleTrigger = (e) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const triggerElements = Array.from(document.querySelectorAll(triggerSelector));

        triggerElements.forEach((triggerElement) => {
            triggerElement.addEventListener(triggerEvent, handleTrigger);
        });

        return () => {
            triggerElements.forEach((triggerElement) => {
                triggerElement.removeEventListener(triggerEvent, handleTrigger);
            });
        };
    }, []);

    return (
        <>
            <ConversionFlowOverlay
                open={open}
                handleClose={handleClose}
                flowUrl={flowUrl}
                webspace={webspace}
                locale={locale}
                overlayBody={(passProps) => {
                    const { flow } = passProps;
                    return (
                        <>
                            <ConversionFlowDatalayer activeStepId={flow?.steps?.find(step => step.active)?.id} flow={flow} datalayerData={datalayerData} />
                            <ConversionFlowForm
                                {...passProps}
                                form={form}
                                handleClose={handleClose}
                            />
                        </>
                    )
                }}
            />
        </>
    );
}
